// extracted by mini-css-extract-plugin
export default {"referralLinkContainer":"referralLinkContainer-75f9"};